module.exports = __webpack_public_path__ + "static/img/16.15262e6b.png";